import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=4a93c8ec&lang=pug&"
import script from "./Home.vue?vue&type=script&lang=babel&"
export * from "./Home.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Home.vue"
export default component.exports